<div class="row container-fluid no-gutters" style="padding: 0px;">
    <div class="col-md-12 d-none d-md-block ">
        <div class="navbar container-fluid text-center">
            <div class="m-auto">
                <nav role="navigation">


                    <ul class="menu-blocks" style="margin-top: -16px;  ">
                        <li *ngIf="cat.length != 0" style="     ">
                            <button class="navbar-toggler" type="button" data-toggle="collapse"
                                    data-target="#navbarSupportedContent"
                                    aria-controls="navbarSupportedContent"
                                    aria-label="Toggle navigation"
                                    style="margin-top: 10px;font-size: 16px;color:#00b9c7;"
                            >
                                <img class="cat-icon" src="assets/icons/all_cats.png"><br>
                                <span style="font-size: 13px;" i18n="@@allproducts"> All Products<br></span>
                                <!--                                <span class="navbar-toggler-icon" style="color: white;"></span>-->
                            </button>
                        </li>
                        <li *ngFor="let c of cat">


                            <a *ngIf="level1_cats[c.id]?.length>0" class="mainmenu-name dropdown-toggle cat-item-block"
                               data-target="#navbarSupportedContent_child_{{c.id}}"
                               type="button" data-toggle="dropdown">
                                <img class="cat-icon" src="assets/icons/{{c.id}}.png"><br>{{c.name}}
                            </a>

                            <a *ngIf="level1_cats[c.id]?.length == 0" (click)="goToCategoriesPage(c.id)" class="mainmenu-name dropdown-toggle cat-item-block"
                               data-target="#navbarSupportedContent_child_{{c.id}}"
                               type="button" data-toggle="dropdown">
                                <img class="cat-icon" src="assets/icons/{{c.id}}.png"><br>{{c.name}}
                            </a>

                            <div *ngIf="level1_cats[c.id].length >0"  class="dropdown-menu subcat_menu"
                                 aria-labelledby="navbarSupportedContent_child_{{c.id}}" style="">

                                <div *ngFor="let cc of level1_cats[c.id]" style=" ">


                                    <a class="dropdown-item" (click)="goToCategoriesPage(cc.id)">{{cc.name}}</a>
                                </div>


                            </div>


                            <!--                            <ul class="dropdown" aria-label="submenu" class="submenu">-->
                            <!--                                <li *ngFor="let ch of cat.children" (click)="goToProductBrowserPage(ch.id)"><a-->
                            <!--                                        class="submenu-name">{{ch.name}}</a></li>-->

                            <!--                            </ul>-->
                        </li>
                        <li>
                            <a [routerLink]="'web/brands'" class="mainmenu-name dropdown-toggle cat-item-block"
                               data-target="#navbarSupportedContent_child_ww"
                               type="button" data-toggle="dropdown">
                                <img class="cat-icon" src="assets/icons/brands.png"><br>Brands
                            </a>
                        </li>
                    </ul>


                    <div class="collapse navbar-collapse" id="navbarSupportedContent" style="position: absolute;top:100px;background-color: #25939c;max-width: 350px;">
                        <app-menu-mega></app-menu-mega>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</div>
